export enum ProfileTemplateFieldMode {
  /** User cannot change this field while the template is applied. */
  LOCKED = 'locked',
  /** Not governed by the template. */
  FREE = 'free',
}

export function normalizePolicyMode(mode?: string): ProfileTemplateFieldMode {
  if (mode === ProfileTemplateFieldMode.LOCKED || mode === 'locked') {
    return ProfileTemplateFieldMode.LOCKED;
  }
  return ProfileTemplateFieldMode.FREE;
}
